import { useState } from 'react';
import {
  WorkspaceLoadingThreeArtifact,
  type WorkspaceLoadingThreeRendererState,
} from '../loading/WorkspaceLoadingThreeArtifact';
import type { ReportGenerationSurfaceTheme } from './types';

export type ReportGenerationPreviewLoadingArtifactProps = {
  active?: boolean;
  surfaceTheme?: ReportGenerationSurfaceTheme;
  statusLabel?: string;
  detailLabel?: string;
  loadingSource?: string;
  className?: string;
};

const joinClasses = (...values: Array<string | false | null | undefined>) =>
  values.filter(Boolean).join(' ');

export function ReportGenerationPreviewLoadingArtifact({
  active = true,
  surfaceTheme = 'light',
  statusLabel = 'Refreshing report data',
  detailLabel = 'Applying latest selection',
  loadingSource = 'rtk-domain-router-preview',
  className = '',
}: ReportGenerationPreviewLoadingArtifactProps) {
  const [rendererState, setRendererState] = useState<WorkspaceLoadingThreeRendererState>('idle');
  const isDark = surfaceTheme === 'dark';

  return (
    <div
      className={joinClasses(
        'flex max-w-[min(360px,calc(100%-32px))] flex-col items-center gap-3 rounded-xl border px-6 py-5 text-center shadow-[0_28px_80px_rgba(0,0,0,0.28)]',
        isDark
          ? 'border-[#1B4A4E]/80 bg-[#071112]/92 text-[#E8EFEF]'
          : 'border-[#CDEEE9] bg-white/94 text-[#1F2E2B]',
        className,
      )}
      role="status"
      aria-live="polite"
      data-testid="report-generation-preview-loading-artifact"
      data-report-generation-surface-theme={surfaceTheme}
      data-renderer-state={rendererState}
      data-loading-source={loadingSource}
      data-artifact-core="intellio-logo"
    >
      <WorkspaceLoadingThreeArtifact
        active={active}
        surfaceTheme={surfaceTheme}
        testId="report-generation-preview-loading-artifact-core"
        onRendererStateChange={setRendererState}
      />
      <div>
        <p className="text-sm font-semibold">{statusLabel}</p>
        <p className={joinClasses('mt-1 text-xs leading-5', isDark ? 'text-[#91A2A6]' : 'text-[#64748B]')}>
          {detailLabel}
        </p>
      </div>
    </div>
  );
}
